import { request } from "./client"

const prefix = "/meta"

export const submitSupportEmail = (data) =>
  request("post", `${prefix}/support/submit`, data)
